import React from "react";
import { L } from "../../l10n/L10n";
import { GameButton, GameButtonStyleType } from "./GameButton";
import Style from "./NoCardsView.module.scss";

const ATOMIC_LINK_HREF = "https://wax.atomichub.io/market?collection_name=tribalbooks";

export const NoCardsView = () => {
	const Content = () => {
		return (
			<>
				<div className={Style.styleCardsNoAssetsYet}>
					You Have no Assets Yet
					<GameButton
						text={L.gameMarket.buy}
						style={GameButtonStyleType.MIDDLE}
						onClick={() => window.open(ATOMIC_LINK_HREF, "_blank")}
					/>
				</div>
			</>
		);
	};

	return (
		<div className={Style.styleCardsContainerSuper}>
			<div className={Style.styleCardsContainer}>
				<Content/>
			</div>
		</div>
	);
};
